<div class="tw-w-full tw-px-4 tw-mb-4">
  <div class="tw-w-full tw-bg-center tw-p-3 tw-rounded-3 tw-cursor-pointer tw-bg-teal-100" (click)="onBannerClick()">
    <div class="tw-flex tw-items-center tw-gap-3">
      <div class="tw-w-15">
        <img class="" src="/assets/icons/gift_white.svg" alt="gift">
      </div>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start">
        <p class="tw-text-300 tw-text-gray-800 tw-font-bold tw-font-lexend" i18n="@@skinStartCompleted">#SkinStart Challenge Completed!</p>
        @if (isClaimed) {
          <p class="tw-text-200 tw-text-gray-500 tw-font-normal tw-flex tw-items-center tw-font-body" i18n="@@rewardClaimed">
            Reward claimed
            <span>
              <img class="tw-w-4" src="/assets/icons/chevron_right.svg" alt="right arrow">
            </span>
          </p>
        } @else {
          <p class="tw-text-200 tw-text-gray-500 tw-font-normal tw-flex tw-items-center tw-font-body" i18n="@@clickToClaimReward">
            Click here to claim your reward
            <span>
              <img class="tw-w-4" src="/assets/icons/chevron_right.svg" alt="right arrow">
            </span>
          </p>
        }
      </div>
    </div>
  </div>
</div>
